var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6651_115927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.375 11.625L11.625 6.37498M6.75 3V1.5M11.25 15V16.5M3 6.75H1.5M15 11.25H16.5M3.68566 3.68566L2.625 2.625M14.3144 14.3143L15.375 15.3749M9.00003 13.2426L7.40904 14.8336C6.23746 16.0051 4.33797 16.0051 3.16639 14.8336C1.99482 13.662 1.99482 11.7625 3.16639 10.5909L4.75739 8.99993M13.2427 8.99993L14.8337 7.40894C16.0052 6.23737 16.0052 4.33788 14.8337 3.1663C13.6621 1.99473 11.7626 1.99473 10.591 3.1663L9.00003 4.75729",
    stroke: "#0E0E0E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.375 11.625L11.625 6.37498M6.75 3V1.5M11.25 15V16.5M3 6.75H1.5M15 11.25H16.5M3.68566 3.68566L2.625 2.625M14.3144 14.3143L15.375 15.3749M9.00003 13.2426L7.40904 14.8336C6.23746 16.0051 4.33797 16.0051 3.16639 14.8336C1.99482 13.662 1.99482 11.7625 3.16639 10.5909L4.75739 8.99993M13.2427 8.99993L14.8337 7.40894C16.0052 6.23737 16.0052 4.33788 14.8337 3.1663C13.6621 1.99473 11.7626 1.99473 10.591 3.1663L9.00003 4.75729",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.375 11.625L11.625 6.37498M6.75 3V1.5M11.25 15V16.5M3 6.75H1.5M15 11.25H16.5M3.68566 3.68566L2.625 2.625M14.3144 14.3143L15.375 15.3749M9.00003 13.2426L7.40904 14.8336C6.23746 16.0051 4.33797 16.0051 3.16639 14.8336C1.99482 13.662 1.99482 11.7625 3.16639 10.5909L4.75739 8.99993M13.2427 8.99993L14.8337 7.40894C16.0052 6.23737 16.0052 4.33788 14.8337 3.1663C13.6621 1.99473 11.7626 1.99473 10.591 3.1663L9.00003 4.75729",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6651_115927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.89d4f3292fc824790341acf7b9f75cc5.svg";
export { ForwardRef as ReactComponent };